import {
  UserUsageReportState,
  UserUsageReportDataActionTypes,
  USER_USAGE_REPORT_LOADING,
  USER_USAGE_REPORT_CLEAR,
  GET_USER_USAGE_REPORT_CUSTOMERS_SUCCESS,
  GET_USER_USAGE_REPORTS_SUCCESS,
  GET_USER_USAGE_REPORT_ACCESS_FLAG_SUCCESS,
} from './UserUsageReport.types';

const defaultState: UserUsageReportState = {
  customers: null,
  reports: null,
  searchCriteria: '',
  loading: false,
  accessFlag: null,
};

export function userUsageReportReducer(
  state = defaultState,
  action: UserUsageReportDataActionTypes,
): UserUsageReportState {
  switch (action.type) {
    case USER_USAGE_REPORT_CLEAR: {
      return {
        ...defaultState,
        customers: state.customers,
        accessFlag: state.accessFlag,
      };
    }
    case USER_USAGE_REPORT_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case GET_USER_USAGE_REPORT_CUSTOMERS_SUCCESS: {
      return {
        ...state,
        customers: action.customers,
        loading: false,
      };
    }
    case GET_USER_USAGE_REPORTS_SUCCESS: {
      return {
        ...state,
        reports: action.result.reports,
        searchCriteria: action.result.searchCriteria,
        loading: false,
      };
    }
    case GET_USER_USAGE_REPORT_ACCESS_FLAG_SUCCESS: {
      return {
        ...state,
        accessFlag: action.accessFlag,
      };
    }
    default:
      return state;
  }
}
